import _ from 'lodash';
import { getManualTranslation } from '../i18n';

const useUtils = () => {
  /**
   * 取得自訂指標
   * @param {array} metrics 需要處理的指標陣列
   * @return {array} 回傳符合條件的指標陣列
   */
  const transformExpressToTw = (expression, allFields, media, reportLanguage) => {
    let newExp = expression.split(' ');

    return newExp.map(el => {
      const match = _.filter(allFields, f => f.expression === el)[0];
      const i18MatchName = match ? getManualTranslation(`${media}.field.${match.expression}`, reportLanguage) : '';
      return match ? i18MatchName : el;
    }).join(' ');
  }

  return [transformExpressToTw];

}

export default useUtils;